import React, { useEffect, useMemo, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  BlockHead,
  BlockBetween,
  BlockHeadContent,
  BlockTitle,
} from "../../components/Component";
import BasePaginationTable from "../../components/table/BasePaginationTable";
import { defaultParams } from "../../constants";
import { getMiLibraryPurchases } from "../../api/mi-library";
import moment from "moment";
import { toast } from "react-toastify";

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  }).format(Number(value || 0));

const getDefaultColumns = () => [
  {
    head: <span className="sub-text">{"Asset / Ads"}</span>,
    cell: (row) => {
      const src = row?.asset?.image || row?.ads?.thumbnail;
      return src ? (
        <img
          src={src}
          alt="asset"
          height={80}
          style={{ objectFit: "contain", width: "auto" }}
        />
      ) : (
        <span>-</span>
      );
    },
  },
  {
    head: <span className="sub-text">{"Cost"}</span>,
    cell: (row) => <span>{formatCurrency(row?.cost || row?.price)}</span>,
  },
  {
    head: <span className="sub-text">{"User"}</span>,
    cell: (row) => (
      <span>{row?.user?.fullName || row?.user?.email || "-"}</span>
    ),
  },
  {
    head: <span className="sub-text">{"Payment Method"}</span>,
    cell: (row) => <span>{row?.paymentMethod || "-"}</span>,
  },
  {
    head: <span className="sub-text">{"Payment Status"}</span>,
    cell: (row) => <span>{row?.paymentStatus || "-"}</span>,
  },
  {
    head: <span className="sub-text">{"Payment Id"}</span>,
    cell: (row) => <span>{row?.paymentId || "-"}</span>,
  },
  {
    head: <span className="sub-text">{"Purchased At"}</span>,
    cell: (row) => (
      <span>
        {row?.createdAt
          ? moment(row.createdAt).format("DD/MM/YYYY HH:mm")
          : "-"}
      </span>
    ),
  },
];

const MiLibraryPurchasesPage = () => {
  const [params, setParams] = useState(defaultParams);
  const [list, setList] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPurchases = async (query = params) => {
    setLoading(true);
    try {
      const res = await getMiLibraryPurchases(query);
      const docs = res?.docs || res?.items || res?.data || res || [];
      const summaryData = res?.summary || res?.pagination;
      setList(docs);
      setSummary(summaryData);
    } catch (error) {
      toast.error(error?.message || "Load purchases failed");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPurchases(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const handlePageChange = (page) => {
    setParams((prev) => ({ ...prev, page }));
  };

  const columns = useMemo(() => getDefaultColumns(), []);

  return (
    <React.Fragment>
      <Head title="MI Library Purchases"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>MI Library Purchases</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent></BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <BasePaginationTable
          list={list}
          loading={loading}
          columns={columns}
          onPageChange={handlePageChange}
          hasNextPage={summary?.hasNextPage}
          totalItems={summary?.count}
          {...params}
        />
      </Content>
    </React.Fragment>
  );
};

export default MiLibraryPurchasesPage;
